'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    notify: {
      position: 'fixed',
      top: 0,
      right: 0,
      zIndex: 2147483647,
      width: theme.notify.width,
      // overflowY: 'auto',
      padding: '0 ' + theme.notify.padding + 'px',
      maxHeight: '100vh'
    },
    animEnter: {
      transform: 'translateY(-100px)'
    },
    animEnterActive: {
      transform: 'translateY(0)',
      transition: 'all 500ms ease-in'
    },
    animExit: {
      transform: 'translateY(0)'
    },
    animExitActive: {
      transition: 'all 500ms ease-in',
      transform: 'translateY(-100px)',
      opacity: 0
    }
  };
};